import isUnitType from './is-unit-type.js';
export default function conversionByRate(ut1, ut2, rate, opts = Object.create(null)) {
    if (!isUnitType(ut1) || !isUnitType(ut2)) {
        throw new Error('Must pass in an instance of UnitType for ut1 and ut2.');
    }
    const { unit1, unit2 } = {
        unit1: String(ut1.defaultUnit),
        unit2: String(ut2.defaultUnit),
        ...opts,
    };
    const u1 = ut1.units[unit1];
    const u2 = ut2.units[unit2];
    if (!u1)
        throw new Error(`unit1 (${unit1}) is not from ut1`);
    if (!u2)
        throw new Error(`unit2 (${unit2}) is not from ut2`);
    return function converter(someNumberUnit) {
        const ut = someNumberUnit.unitType;
        if (ut.equals(ut1)) {
            const newUnit = ut2.baseUnit(someNumberUnit._number).mul(u2.multiplier).mul(rate);
            newUnit._number = newUnit._number.div(u1.multiplier);
            return newUnit.to(unit2);
        }
        if (ut.equals(ut2)) {
            let newUnit = ut1.baseUnit(someNumberUnit._number).mul(u1.multiplier);
            try {
                newUnit = newUnit.div(rate);
            }
            catch (err) {
                if (String(err.message) !== 'Invalid division by 0')
                    throw err;
                newUnit = ut1.baseUnit(0);
            }
            newUnit._number = newUnit._number.div(u2.multiplier);
            return newUnit.to(unit1);
        }
        throw new Error('Conversion error');
    };
}
